import React, { useEffect, useState } from "react";

import { useAnalyticsTracker } from "components/instrumentation/source/analytics";
import { useAppContext } from "components/store/source";
import { Modal } from "components/ui/source";
import { LoadingLayout } from "components/ui/source/layouts";

import { useNavbarRendered } from "../Navbar/Navbar";

import LoginForm from "./LoginForm";

import styles from "./Accounts.module.scss";

// analytics.track causes rerender.
function LogInPopupEvent({ loginPopupIsOpen, loginPopupProps }) {
  const { analytics } = useAnalyticsTracker();

  useEffect(() => {
    if (loginPopupIsOpen) {
      analytics.track("Sign In Page Load", {
        source: loginPopupProps.source,
      });
    }
  }, [loginPopupIsOpen]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
}

function LogInPopup() {
  const {
    loginPopupIsOpen,
    loginPopupProps,
    closeLoginPopup,
    openSignUpPopup,
  } = useAppContext();
  const [isLoading, setLoading] = useState(false);
  const { analytics } = useAnalyticsTracker();
  const isNavbarRendered = useNavbarRendered();

  const modalProps = {
    isOpen: loginPopupIsOpen,
    onRequestClose: closeLoginPopup,
    shouldCloseOnOverlayClick: !isLoading,
    shouldCloseOnEsc: !isLoading,
    className: styles.modal,
    aria: {
      labelledby: "loginFormHeading",
    },
  };

  const trackLogInSubmit = async (signInMethod, email) => {
    try {
      await analytics.track("Sonder Login Attempt", {
        email,
        method: signInMethod,
        source: loginPopupProps.source,
      });
    } catch {
      // do nothing
    }
  };

  return isNavbarRendered ? (
    <Modal modalProps={modalProps}>
      <LogInPopupEvent
        loginPopupIsOpen={loginPopupIsOpen}
        loginPopupProps={loginPopupProps}
      />
      <LoadingLayout loading={isLoading}>
        <Modal.Close onClick={closeLoginPopup} disabled={isLoading} />
        <LoginForm
          openSignUpPopup={() =>
            openSignUpPopup({ source: loginPopupProps.source })
          }
          closePopup={closeLoginPopup}
          logSubmit={trackLogInSubmit}
          setLoading={setLoading}
          {...loginPopupProps}
        />
      </LoadingLayout>
    </Modal>
  ) : null;
}

export default LogInPopup;
